import type { FeatureStepsContent } from '@/core/types';

import { FeatureStepsV1 } from '@/containers/blocks/features';

export default function generate({
  content,
  className,
}: {
  content: FeatureStepsContent;
  className?: string;
}) {
  return <FeatureStepsV1 steps={content.steps} className={className} />;
}
